import { NgModule, Injector } from '@angular/core';

// components
import { HomeComponent } from './home.component';
import { QuoteCardComponent } from './quote-card/quote-card.component';
import { QuoteCardConversionComponent } from './quote-card/quote-card-conversion.component';
import { QuoteCardTextDescriptionComponent } from './quote-card/quote-card-text-description/quote-card-text-description.component';
import { QuoteCardConversionTextDescriptionComponent } from './quote-card/quote-card-conversion-text-description copy/quote-card-conversion-text-description.component';
import { WholeLifeVisualizationComponent } from './quote-card/whole-life-visualization/whole-life-visualization.component';
import { ClientCostBreakdown } from './quote-card/client-cost-breakdown/client-cost-breakdown.component';
import { AnnuityQuoteCardComponent } from './annuity-quote-card/annuity-quote-card.component';
import { CpPopoverModule } from '../../../../../coverpath-common/components/cp-popover/cp-popover.module';

// services
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { QuoteService } from '../../../../../coverpath-common/angular/services/quote/quote.service';
import { VSTService } from '../../../../../coverpath-common/advisor-sales-tools/services/vst.service';
import { BasicIllustrationService } from '../../../../../coverpath-common/angular/services/basicillustration/BasicIllustrationService';

// modules
import { BaseFormModule } from '../../../../../coverpath-common/angular/components/form/base-form.module';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../../../coverpath-common/angular/components/shared/shared.module';
import { LoadingModule } from '../../../../../coverpath-common/angular/components/shared/loading/loading.module';
import { SpinnerModule } from '../../../../../coverpath-common/angular/components/shared/spinner/spinner.module';
import { RouterModule } from '@angular/router';
import { QuoteModule } from '../quote/quote.module';
import { VstModule } from '../../../../../coverpath-common/advisor-sales-tools/components/visual-sales-tool/vst.module';
import { DesignSystemModule } from '@hit/coverpath-design-system';
import { AlertModule } from '../../../../../coverpath-common/angular/components/shared/alert/alert.module';

@NgModule({
  declarations: [
    HomeComponent,
    QuoteCardComponent,
    QuoteCardConversionComponent,
    QuoteCardTextDescriptionComponent,
    QuoteCardConversionTextDescriptionComponent,
    WholeLifeVisualizationComponent,
    ClientCostBreakdown,
    AnnuityQuoteCardComponent,
  ],
  imports: [
    BaseFormModule,
    RouterModule,
    SharedModule,
    LoadingModule,
    SpinnerModule,
    CommonModule,
    QuoteModule,
    VstModule,
    DesignSystemModule,
    AlertModule,
    CpPopoverModule,
  ],
  exports: [HomeComponent],
  providers: [AmorphicService, QuoteService, VSTService, BasicIllustrationService],
  bootstrap: [HomeComponent],
})
export class HomeModule {
  /**
   * Allows for retrieving singletons using `AppModule.injector.get(MyService)`
   * (whereas `ReflectiveInjector.resolveAndCreate(MyService)` would create a
   * new instance of the service).
   */
  static injector: Injector;
  constructor(injector: Injector) {
    HomeModule.injector = injector;
  }
}
